export default __webpack_public_path__ + "i18n/translations/translation-pl.647e48d7.json";